var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person-filter-content"},[_c('quick-filter-panel',{ref:"filterPanel",attrs:{"fields":_vm.filterFields,"values":_vm.filterValues,"title":"Filter People","show-header":false},on:{"update":_vm.handleFilterUpdate,"clear":_vm.resetFilters}})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }